import AgendaCard from './container';

export default AgendaCard;



// WEBPACK FOOTER //
// ./src/components/Cards/AgendaCard/index.js